import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg"
import { Form } from "../Form/Form";


export function Contact() {

  return (
    <Container id="contato">
      <header>
        <h2>Contactez-moi</h2>
        <p>Si vous avez vu mon potentiel ou si vous voulez discuter avec moi, n'hésitez pas à m'envoyer un message.</p>
      </header>
      <div className="contacts">
        <div>
          <img src={emailIcon} alt="Email" />
          <a href="mailto:agbetewijean@gmail.com">agbetewijean@gmail.com</a>
        </div>
        <div>
          <img src={phoneIcon} alt="Email" />
          <a href="tel:+22892103138">(00228) 92103138</a>
        </div>
      </div>
      <Form></Form>
    </Container>
  )
}